const generateBackgroundColors = (colorLength: number = 3): {
    colors: string[];
    baseColors:[number, number, number][];
    baseColorsFormatted: string[];
} => {
    const colors = []; 
    const variationFactor = 50;
    const baseColors: [number, number, number][] = [[255, 106, 38],[0, 119, 204],[188, 188, 188]];

    const baseColorsFormatted = baseColors.map(
        ([r,g,b]) => `rgba(${r}, ${g}, ${b})`
    );
    
    for(let i = 0; i < colorLength; i++) {
        const baseColor = baseColors[i % baseColors.length];
        const [r,g,b] = baseColor;
        const newR = Math.min(255, r + (i / baseColors.length) * variationFactor) % 256;
        const newG = Math.min(255, g + (i / baseColors.length) * variationFactor) % 256;
        const newB = Math.min(255, b + (i / baseColors.length) * variationFactor) % 256;
        colors.push(`rgb(${newR}, ${newG}, ${newB})`);
    }
    
    return {colors, baseColors, baseColorsFormatted};
}

export default generateBackgroundColors;